import { Box, Breadcrumbs, Button, TextField, Typography } from "@mui/material";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import MainScreen from "../../Components/Navbar/MainScreen";
import "./UserDetails.css";
import CustomTextArea from "../../Components/CustomTextArea/CustomTextArea";

function UserDetails() {
  const navigate = useNavigate();
  return (
    <MainScreen>
      <Box
        sx={{
          p: 2,
        }}
        className="user-details-container"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            // marginTop: 15,
            backgroundColor: "#fff",
            // padding: 5,
          }}
        >
          <div
            style={{
              display: "flex",
              // marginTop: 5,
            }}
          >
            <div className="gray-arrow-container">True ATS+</div>
            <div className="blue-arrow-container">Home</div>
          </div>
        </div>
        {/* <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "1.1rem" }}>
          <span
            to="/"
            style={{
              color: "#263238",
              // fontWeight: "bold",
              textDecoration: "none",
              display: "inline-block",
              "&:hover": { color: "#119a80" },
            }}
          >
            ATS++
          </span>

          <Typography
            sx={{
              color: "#ff9800",
              fontWeight: "bold",
            }}
          >
            User Details
          </Typography>
        </Breadcrumbs> */}

        <CustomTextArea
          label="Enter your message"
          multiline
          rows={4}
          fullWidth
          variant="outlined"
          margin="normal"
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
              "& fieldset": {
                borderColor: "#14bc9a", // Default border color
              },
              "&:hover fieldset": {
                borderColor: "#119a80", // Border color on hover
              },
              "&.Mui-focused fieldset": {
                borderColor: "#ff9800", // Border color when focused
              },
            },
            "& .MuiInputLabel-root": {
              color: "#14bc9a", // Label color
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#ff9800", // Label color when focused
            },
          }}
        />

        <Box display="flex" gap={3}>
          <Button
            variant="contained"
            onClick={() => {
              navigate("/search-database");
            }}
            sx={{
              backgroundColor: "#14bc9a",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#119a80",
              },
            }}
          >
            Search Talent
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              navigate("/upload-file");
            }}
            sx={{
              backgroundColor: "#fd815e",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#fd815e",
              },
            }}
          >
            Upload new Document
          </Button>
          {/* 
          <Button
            variant="outlined"
            onClick={() => {
              navigate("/upload-file");
            }}
          >
            Upload new Document
          </Button> */}
        </Box>
      </Box>
    </MainScreen>
  );
}

export default UserDetails;
